import { useState } from "react"

const navLinks = [
  { label: "Home", href: "home" },
  { label: "About", href: "about" },
  { label: "Services", href: "services" },
  { label: "Gallery", href: "gallery" },
  { label: "Contact", href: "contact" },
]

function scrollTo(id: string) {
  const el = document.getElementById(id)
  if (el) {
    el.scrollIntoView({ behavior: "smooth" })
    const path = id === "home" ? "/" : `/${id}`
    history.pushState(null, "", path)
  }
}

export function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <nav className="fixed top-0 left-0 z-50 w-full border-b border-gray-200 bg-white/95 backdrop-blur-sm">
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-8 py-2">
        {/* Logo */}
        <button type="button" onClick={() => scrollTo("home")} className="flex items-center">
          <img src="/logo.svg" alt="Design Inside by Vicky" className="h-20 w-auto" />
        </button>

        {/* Desktop nav links */}
        <div className="hidden items-center gap-8 md:flex">
          {navLinks.map((link) => (
            <button
              key={link.href}
              type="button"
              onClick={() => scrollTo(link.href)}
              className="cursor-pointer relative text-[13px] font-light tracking-[0.15em] text-navy-muted uppercase transition-colors hover:text-navy after:absolute after:bottom-0 after:left-0 after:h-px after:w-0 after:bg-navy after:transition-all after:duration-300 hover:after:w-full"
            >
              {link.label}
            </button>
          ))}
          <button
            type="button"
            onClick={() => scrollTo("booking")}
            className="border border-navy bg-navy px-5 py-2 text-[12px] font-light tracking-[0.15em] text-white uppercase transition-all hover:bg-transparent hover:text-navy"
          >
            Book Now
          </button>
        </div>

        {/* Hamburger */}
        <button
          className="flex flex-col gap-[5px] md:hidden"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Menu"
        >
          <span className={`h-[1.5px] w-6 bg-navy transition-all duration-300 ${mobileOpen ? "translate-y-[6.5px] rotate-45" : ""}`} />
          <span className={`h-[1.5px] w-6 bg-navy transition-all duration-300 ${mobileOpen ? "opacity-0" : ""}`} />
          <span className={`h-[1.5px] w-6 bg-navy transition-all duration-300 ${mobileOpen ? "-translate-y-[6.5px] -rotate-45" : ""}`} />
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`overflow-hidden border-t border-gray-200 bg-white transition-all duration-400 md:hidden ${
          mobileOpen ? "max-h-[400px]" : "max-h-0"
        }`}
      >
        <div className="flex flex-col px-8 py-6">
          {navLinks.map((link) => (
            <button
              key={link.href}
              type="button"
              onClick={() => { scrollTo(link.href); setMobileOpen(false) }}
              className="border-b border-gray-100 py-3 text-left text-[13px] font-light tracking-[0.15em] text-navy-muted uppercase"
            >
              {link.label}
            </button>
          ))}
          <button
            type="button"
            onClick={() => { scrollTo("booking"); setMobileOpen(false) }}
            className="mt-4 border border-navy bg-navy py-3 text-center text-[12px] font-light tracking-[0.15em] text-white uppercase"
          >
            Book Now
          </button>
        </div>
      </div>
    </nav>
  )
}
